function Blank(){
  
  return (
    <div style={{minHeight:'100vh'}}></div>
    );
  
}

export default Blank;